/**
 * @generated SignedSource<<dee8f57d3775a1a84a30a68280747c3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryQuantitySelect_transaction$data = {
  readonly sku: {
    readonly availableQuantity: number | null;
    readonly hasUnlimitedQuantity: boolean | null;
    readonly quantitySelectOptions: ReadonlyArray<{
      readonly label: string | null;
      readonly value: number | null;
    } | null> | null;
    readonly setSize: number | null;
  } | null;
  readonly " $fragmentType": "CheckoutMobileSummaryQuantitySelect_transaction";
};
export type CheckoutMobileSummaryQuantitySelect_transaction$key = {
  readonly " $data"?: CheckoutMobileSummaryQuantitySelect_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryQuantitySelect_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryQuantitySelect_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "alias": "availableQuantity",
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasUnlimitedQuantity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkuQuantityOption",
          "kind": "LinkedField",
          "name": "quantitySelectOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "setSize",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "c1504116878d9c11914eae65a285cdea";

export default node;
